var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"mb-2"},[_c('h5',[_c('router-link',{attrs:{"to":{ name: 'Case', params: { id: _vm.item.id }}}},[_c('h5',[_vm._v(_vm._s(_vm.item.name))])])],1)])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }